import _ from 'lodash';

// TODO: remove this ignore when we have a fix for "no exported member"
// due to ar-feature-gating exporting the split client with *
// @ts-ignore
import { provisioningClient, splitClient } from '@nextroll/ar-feature-gating';

// These flags are listed in historical order.
// Flags at the top are older and likely candidates for removal.

// Flag used to tell if the user should have access to the email notification action node.
export const RW_WORKFLOWS_EMAIL_NOTIFICATION = 'rw-workflows-email-notification';

// determine the visibility of feature: contact redemption > CRM > send-email node
export const RW_WORKFLOWS_SEND_CONTACTS_IN_EMAIL = 'rw-workflows-send-contacts-in-email';

export const isFeatureFlagEnabled = _.memoize((name: any) => {
    try {
        return splitClient.getTreatment(name) === 'on';
    } catch (e) {
        console.error(e);
        return false;
    }
});

export const getFeatureFlagConfig = _.memoize((name: any) => {
    try {
        return splitClient.getTreatmentWithConfig(name);
    } catch (e) {
        console.error(e);
        return { treatment: false, config: null };
    }
});

/**
 * get the WORKFLOWS provisioning client; so far we only use the "quantity" value
 */
interface IWorkflowsFeature { feature?: string; enabled?: boolean; quantity: number }
export const getWorkflowsFeature = _.memoize(() => {
    try {
        return provisioningClient.getFeature('WORKFLOWS') as IWorkflowsFeature;
    } catch (e) {
        console.error(e);
        return { quantity: 25 } as IWorkflowsFeature;
    }
});
